<template>
	<div class="ReSearchMObjMap">
		<yandex-map
			:settings="yamap_settings"
			:coords="yamap_coords"
			:zoom="yamap_zoom"
			:controls="yamap_controls"
			:scroll-zoom="true"
			:cluster-options="clusterOptions"
			:use-html-in-layout="true"
			>
				<ymap-marker v-for="marker in yamap_markers" :key="marker.id"
					:coords="marker.coords"
					:marker-id="marker.id"
					:icon="{color: marker.markerColor, content: marker.houseClassMarker}"
					:balloon-template="marker.balloonTemplate"
					:balloon="marker.clusterBalloonTemplate"
					cluster-name="cluster"
				/>
		</yandex-map>
		
		<!-- <pre>{{ objData[0] }}</pre> -->
	</div>
	
</template>

<script>
	import { yandexMap, ymapMarker } from 'vue-yandex-maps';
	import mapSettings from 'src/conf/yandexmap.js';
	export default {
		name: 'ReSearchMObjMap',
		components: { 
			yandexMap, 
			ymapMarker
		},
		props: {
			objData: [Object,Array]
		},
		data () {
			return {
				ver: 1,
				yamap_settings: { ...mapSettings	},
				yamap_coords: [59.93984485554249, 30.314527237792984],
				yamap_zoom: 11,
				yamap_controls:['zoomControl','typeSelector'],
				yamap_markers:[],
				clusterOptions: {
					clusterDisableClickZoom: true,
					clusterOpenBalloonOnClick: true,
				},
				updateTimer:null,
				fullscreenLoading: false,
			}
		},
		watch: {
			// objData:{
			// 	handler: function(val){
			// 		console.log('watch objData',val);
			// 		console.log('watch objData to log');
			// 		this.makeMarkers();
			// 	},
			// 	// deep: true,
			// 	immediate: true

			// },
			objData(val){
				// console.log('watch objData',val);
				this.makeMarkers();
			}
		},
		methods: {
			makeMarkers(){
				this.yamap_markers = [];
				// let markers=[];
				const objGetParams = this.$GVO.GetAllGet();

				for (let i = 0; i < this.objData.length; i++) {
					const objSecond = this.objData[i];
					// console.log(this.objData[i]);
					const houseClassMarker = 'ID Объекта ' + this.objData[i].id;
					const markerColor = 'lightBlue';
					
					let strConstGetParams = '';
					if(typeof objGetParams.task_id != 'undefined' && typeof objGetParams.taskend_id != 'undefined' && typeof objGetParams.client_id != 'undefined'){
						strConstGetParams = `?task_id=${objGetParams.task_id}&taskend_id=${objGetParams.taskend_id}&client_id=${objGetParams.client_id}`;
					}
					let strObjUrl = '/data/module/mo/object/'+objSecond.id+strConstGetParams;  

					let metroBaloon = '';
					if(objSecond.MapAddress && objSecond.MapAddress.arrMetro.length > 0 && objSecond.MapAddress.arrMetro[0].metro_name !=''){
						metroBaloon = `<div class="metroPathTime mr-2">
											<i class="tim-ic ic-metro mr-2 text-primary"></i>
											<p class="">${objSecond.MapAddress.arrMetro[0].metro_name}</p>
										</div>`;
										// console.log('objSecond.MapAddress.arrMetro', objSecond.id, objSecond.MapAddress.arrMetro);
					}else metroBaloon = '';	

					let units='';				
					let kitchen='';				
					let land='';
					let moderationStatus='';
					let moderationBage='';

					if(objSecond.moderation_status_id != '' && objSecond.moderation_status_id == 2){
						moderationStatus = 'Объект принят';
						moderationBage = 'badge-success';
					} else if (objSecond.moderation_status_id != '' && objSecond.moderation_status_id == 3){
						moderationStatus = 'Объект отклонен';
						moderationBage = 'badge-danger';
					} else {
						moderationStatus ='Объект не проверен';
						moderationBage = 'badge-default';
					}

					if(objSecond.square!='' && objSecond.objectType!='Земля' && objSecond.objectType!='Комм.Земля'){
						units = 'м²';
					} else units ='сот';	

					if(objSecond.kitchenSquare && objSecond.kitchenSquare!=''){
						kitchen = `<div class="complexName"><p>S кухни ${this.$GVO.number_format(objSecond.kitchenSquare,0,'.',' ')} м²</p></div>`
					} else kitchen ='';	
					if(objSecond.landSquare && objSecond.landSquare!=''){
						land = `<div class="complexName"><p>S участка ${this.$GVO.number_format(objSecond.landSquare,0,'.',' ')} сот</p></div>`
					} else land ='';	

					let objPhoto = '';
					if(objSecond.photos && objSecond.photos.length > 0){
						objPhoto = `<img alt="" onerror="this.src='/img/flatsDefault.svg'; this.onerror=''" src="${objSecond.photos[0]}">`
					} else objPhoto ='';	

					let latitude = null; // было const, но оно внезапно стало read only?
					let longitude = null; // было const, но оно внезапно стало read only?

					if(objSecond.MapAddress.coords[0] && objSecond.MapAddress.coords[0]!=''){
						latitude = parseFloat(objSecond.MapAddress.coords[0]);
					}
					if(objSecond.MapAddress.coords[1] && objSecond.MapAddress.coords[1]!=''){
						longitude = parseFloat(objSecond.MapAddress.coords[1]);
					}

					this.yamap_markers.push({
						id: i,
						markerId: i,
						// coords: [objSecond.MapAddress.coords[0], objSecond.MapAddress.coords[1]],
						coords: [latitude, longitude],
											
						markerColor: markerColor,
						houseClassMarker: houseClassMarker,
						clusterBalloonTemplate: {
							header: `Адрес: ${objSecond.MapAddress.address.inputText}`,

							body: [
								[
								'ID: ' + objSecond.id, 
								'Цена: ' + this.$GVO.number_format(objSecond.price,0,'.',' ') + ' ₽', 
								'<a href="'+ strObjUrl +'">Посмотреть объект № ' +objSecond.id+ '</a>'
								].join('<br/>'),
							],
						},
						balloonTemplate: `
							<div class="cardComplex" style="height: auto !important;">
								<div class="img">
									<a href="${strObjUrl}">
										${objPhoto}
									</a>
								</div>

								<div class="row align-items-center mx-0 mt-3">
									<span class="badge ${moderationBage} mr-2" style="font-size: 12px;">${moderationStatus} </span>
								</div>	

								<div class="objInfo">
									<div>Объект № ${objSecond.id}</div>
									<div class="complexName"><a href="${strObjUrl}">${objSecond.name}</a></div> 
									<div>${metroBaloon}</div>
									<div class="complexName"><p>S общая ${this.$GVO.number_format(objSecond.square,0,'.',' ')} ${units}</p></div>
									${land}
									${kitchen}
									<div class="price"><p>Цена: ${this.$GVO.number_format(objSecond.price,0,'.',' ')} ₽</p></div>
								</div>
							</div>
						`
					});
				}
				// console.log('add markers',this.yamap_markers.length);
				// clearTimeout(this.updateTimer);
				// this.updateTimer= setTimeout(()=>{
				// 	this.yamap_markers=markers;
				// },10);
				// this.yamap_markers=[];
			}
		},
		mounted() {
			// console.log('mounted objData',this.objData);
			this.makeMarkers();
		}
	}
</script>
<style>
	.ymap-container{height: 600px; width: 100%;}
	.ReSearchMObjMap{position: relative; width: 100%;}
	.cardComplex .img{
		width: 100%;
		margin: 0 auto;
    	display: flex;
		margin-bottom: 15px;
		padding-top: 15px;
	}
	.cardComplex .img img{max-width: 300px; object-fit: cover; height: 180px;}
	.cardComplex .img a{display: inline-block; margin: 0 auto;}
	.cardComplex p {color: #000;}
	.complexName {margin-bottom: 5px;}
	.metroPathTime, .districtStreet {display: flex; align-items: center;}
	.objInfo {padding: 0px 10px;}
	.flatCount {margin-bottom: 5px;}
	.ymaps-2-1-77-balloon__content{
		margin-right: 0px!important;
		padding: 20px!important;
	}
	/*===media===============================*/
	@media (max-width: 768px) {	
		.ymap-container {height: 450px;}
	}
</style>
